import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/constant';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var GetAllUserCreatedRolesAction = function () {

}


GetAllUserCreatedRolesAction.prototype = {

	getAllUserCreatedRoles: function (profileId) {

		restClient.getAllUserCreatedRoles(profileId,function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else{
					AppDispatcher.dispatch({
						actionType: Constant.GET_ALL_USER_ROLE,
						data: error
					});
				}
			} else {
				//response['status']= 200;
				AppDispatcher.dispatch({
					actionType: Constant.GET_ALL_USER_ROLE,
					data: response
				});
			}
		})
	}
}

export default new GetAllUserCreatedRolesAction();